/**
 * Копирование в буфер обмена.
 *
 * Принимает строку или промис строки. Промис нужен, когда значение ещё
 * надо запросить с сервера (секрет приложения): Safari разрешает запись
 * в буфер только синхронно внутри клика, поэтому промис передаётся
 * в ClipboardItem сразу, а не после await.
 */
export async function copyText(value) {
  if (typeof ClipboardItem !== 'undefined' && navigator.clipboard?.write) {
    try {
      const blob = Promise.resolve(value).then((text) => new Blob([text], { type: 'text/plain' }));
      await navigator.clipboard.write([new ClipboardItem({ 'text/plain': blob })]);
      return;
    } catch {
      // Ошибку запроса за значением отдаём наверх, остальное — пробуем запасной путь
      await value;
    }
  }

  const text = await value;

  if (navigator.clipboard?.writeText) {
    try {
      await navigator.clipboard.writeText(text);
      return;
    } catch {
      // Нет разрешения или небезопасный контекст — ниже execCommand
    }
  }

  const textarea = document.createElement('textarea');
  textarea.value = text;
  textarea.setAttribute('readonly', '');
  textarea.style.position = 'fixed';
  textarea.style.opacity = '0';
  document.body.appendChild(textarea);
  textarea.select();
  const ok = document.execCommand('copy');
  document.body.removeChild(textarea);

  if (!ok) {
    throw new Error('Clipboard is not available');
  }
}
